// Eje 3 — Tipo de falla, transversal a todas las especialidades
// (hoja "Tipos de falla" del xlsx). Lista cerrada de 18 (v1 tenía 21:
// se fusionaron los pares que en terreno se resolvían al azar). La
// columna "severidad más frecuente" de v1 fue eliminada a propósito —
// contradecía la regla de severidad derivada y anclaba al humano; si
// alguna vez vuelve, es como prior de booleanos en el prompt del
// clasificador, jamás como S-codes ni en la UI (ADR-0129).
export const TIPOS_FALLA = [
    {
        codigo: "TF-01",
        nombre: "Fisura o grieta",
        criterio: "Abertura lineal en material rígido. Registrar ancho_mm si se dispone de galga; si no, foto con referencia de escala.",
        campoAdicional: "ancho_mm",
    },
    {
        codigo: "TF-02",
        nombre: "Trizadura o quiebre",
        criterio: "Rotura de material rígido: cristal, cerámica, cubierta de mesón.",
    },
    {
        codigo: "TF-03",
        nombre: "Desprendimiento o elemento suelto",
        criterio: "El elemento se separó de su base o su fijación es insuficiente o ausente.",
    },
    {
        codigo: "TF-04",
        nombre: "Humedad, filtración o fuga",
        criterio: "Presencia de agua, humedad o escape de gas fuera de su conducto o de la envolvente.",
        campoAdicional: "agua_activa",
    },
    {
        codigo: "TF-05",
        nombre: "Condensación u hongos",
        criterio: "Moho o condensación superficial recurrente. Separado de TF-04 porque el moho SÍ es observable.",
    },
    {
        codigo: "TF-06",
        nombre: "Corrosión",
        criterio: "Óxido en elemento metálico. Distinguir superficial de activa con pérdida de sección.",
    },
    {
        codigo: "TF-07",
        nombre: "Deformación o alabeo",
        criterio: "Pérdida de geometría del elemento: pandeo, torcedura, combado.",
    },
    {
        codigo: "TF-08",
        nombre: "Desnivel o desplome",
        criterio: "Fuera de horizontalidad o verticalidad, perceptible bajo la condición de inspección.",
    },
    {
        codigo: "TF-09",
        nombre: "Holgura o desajuste",
        criterio: "Separación o calce incorrecto entre piezas.",
    },
    {
        codigo: "TF-10",
        nombre: "Elemento faltante",
        criterio: "Pieza especificada que no fue instalada.",
    },
    {
        codigo: "TF-11",
        nombre: "Sello deficiente o ausente",
        criterio: "Silicona, mortero o junta discontinua, agrietada o no ejecutada.",
    },
    {
        codigo: "TF-12",
        nombre: "Obstrucción",
        criterio: "Flujo impedido en ducto, desagüe o ventilación.",
    },
    {
        codigo: "TF-13",
        nombre: "No opera",
        criterio: "El elemento no cumple ninguna de sus funciones.",
    },
    {
        codigo: "TF-14",
        nombre: "Operación deficiente",
        criterio: "Opera, pero fuera de parámetro: caudal, temperatura, recorrido, intermitencia.",
    },
    {
        codigo: "TF-15",
        nombre: "Ruido o vibración",
        criterio: "Emisión anómala en operación o por viento.",
    },
    {
        codigo: "TF-16",
        nombre: "Daño superficial",
        criterio: "Rayadura, golpe, mancha, picadura. Sin efecto funcional.",
    },
    {
        codigo: "TF-17",
        nombre: "Terminación deficiente",
        criterio: "Ejecución bajo estándar: escurrimiento, borde irregular, desalineación, tono disparejo.",
    },
    {
        codigo: "TF-18",
        nombre: "Aseo",
        criterio: "Residuos de obra, adhesivos, salpicaduras, protecciones no retiradas.",
    },
];
//# sourceMappingURL=tipos-falla.js.map